var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#schedule_svg__clip0_2746_102170)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFB54C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 1.6,
    height: 3,
    rx: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 5,
    width: 1.6,
    height: 3,
    rx: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.75C5 6.784 5.784 6 6.75 6h10.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0117.25 18H6.75A1.75 1.75 0 015 16.25v-8.5zM8 10a.8.8 0 01.8-.8h6.4a.8.8 0 010 1.6H8.8A.8.8 0 018 10zm.8 2.7a.8.8 0 000 1.6h3.4a.8.8 0 000-1.6H8.8z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "schedule_svg__clip0_2746_102170"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default __webpack_public_path__ + "static/schedule.698b803a.svg";
export { SvgSchedule as ReactComponent };